<div class="card header container-fluid">
	<div *ngIf="(customFunctionAppInfo$ | async)" style="transform: scale(0.65); z-index: 100;" class="ribbon ribbon-top-left-beta hover-target"><span>Beta</span></div>
	<div *ngIf="(customFunctionAppInfo$ | async) as info" class="hover-popup">
		<h6>This link executes a custom version.</h6>
		<ng-container *ngIf="info.sourceApp">
			Custom source: {{info.sourceApp.functionAppName}} <br>
		</ng-container>
		<ng-container *ngIf="info.targetApp">
			Custom target: {{info.targetApp.functionAppName}} <br>
		</ng-container>
		<ng-container *ngIf="info.globalApp">
			Custom global: {{info.globalApp.functionAppName}} <br>
		</ng-container>
		<ng-container *ngIf="info.entryPointApp">
			Custom entry point: {{info.entryPointApp.functionAppName}} <br>
		</ng-container>
	</div>


	<div class="ribbon ribbon-top-right danger" *ngIf="link.expiryDate && hasPassed(link.expiryDate)">
		<span>EXPIRED</span>
	</div>


	<div class="row" *ngIf="linkInfo">
		<!-- <div class="col-lg-4 col-xl app-icons">
			<img class="icon" [src]="getUrl('/application-logos/'+linkInfo.fromImageRef)" />
			<img class="link" [src]="getUrl('/application-logos/applicationlinklink.png')" />
			<img class="icon" [src]="getUrl('/application-logos/'+linkInfo.toImageRef)" />
		</div> -->
		<div style="padding-left: 50px" class="col-lg-6 info">
			<div class="row title-header">
				<div class="short" [class.admin]="canManageApplicationLinkAdministration" [class.clickable]="canManageApplicationLinkAdministration" (click)="openModalTitle()">
					<h2>{{ linkInfo.displayName }}</h2>
					<i *ngIf="canManageApplicationLinkAdministration" class="far fa-pen"></i>
				</div>
				<div class="header-status-group">
					<div *ngIf="currentStatusColorSubject.asObservable() | async as itemStatus">
						<div [ngClass]="{'alert-success': itemStatus===linkStatusCode.Success, 'alert-info': itemStatus===linkStatusCode.Info, 'alert-danger': itemStatus===linkStatusCode.Danger}" class="alert">{{ currentStatusSubject.asObservable() | async }}</div>
					</div>
					<div *ngIf="isMapperEnabled" class="mapper-banner-indicator" data-cy="generic-mapper-active-indicator" title="This link is using the generic mapper.">
						<i class="far fa-exchange"></i>
						<span>Generic mapper</span>
					</div>
				</div>
			</div>
			<hr>
			<div class="short" [class.admin]="canManageApplicationLinkAdministration" [class.clickable]="canManageApplicationLinkAdministration" (click)="openModalShort()">
				<div [innerHTML]="linkInfo.shortDescription">
				</div>
				<i *ngIf="canManageApplicationLinkAdministration" class="far fa-pen"></i>
			</div>
		</div>
		<div class="col-lg right">
			<div class="run">
				<!-- <i class="far fa-trash-alt"></i> -->
				<!-- <i class="far fa-trash fa-3x" (click)="deleteLink()"></i> -->
				<div style="margin-top: 5px" *ngIf="{linkStatus: disabledRunLinkButtonObservable | async, canRunLinks: canRunLinks$ | async} as linkContext">

					<span *ngIf="linkContext.linkStatus == linkRunStatus.inactive && linkContext.canRunLinks" class="arrow" (click)="pressPlay()"><i
                            class="far fa-play fa-3x arrowicon clickable fa-fw"></i></span>
					<span *ngIf="linkContext.linkStatus == linkRunStatus.undefined || linkContext.linkStatus == linkRunStatus.inactive && !linkContext.canRunLinks" style="opacity: 0.3; pointer-events: none;" class="arrow"><i class="far fa-play fa-3x arrowicon"></i></span>
					<span *ngIf="linkContext.linkStatus == linkRunStatus.active" title="Processing" class="processing" (click)="$event.stopPropagation();">
                        <div style="
					transform: scale(0.15);
					transform-origin: top left;
					position: absolute;
					top: -40px;
					left: -37px;
				">
                            <svg class="machine" x="0px" y="0px" viewBox="0 0 645 526" style="
					width: 800px;
					height: 800px">
                                <defs />
                                <g>
                                    <path x="-173,694" y="-173,694" class="large"
                                        d="M635 184v-21l-29-4c-1-10-3-19-6-28l25-14 -8-19 -28 7c-5-8-10-16-16-24L592 58l-15-15 -23 17c-7-6-15-11-24-16l7-28 -19-8 -14 25c-9-3-18-5-28-6L472 0h-21l-4 29c-10 1-19 3-28 6L405 9l-19 8 7 28c-8 5-16 10-24 16l-23-17L331 58l17 23c-6 7-11 15-16 24l-28-7 -8 19 25 14c-3 9-5 18-6 28l-29 4v21l29 4c1 10 3 19 6 28l-25 14 8 19 28-7c5 8 10 16 16 24l-17 23 15 15 23-17c7 6 15 11 24 16l-7 28 19 8 14-25c9 3 18 5 28 6l4 29h21l4-29c10-1 19-3 28-6l14 25 19-8 -7-28c8-5 16-10 24-16l23 17 15-15 -17-23c6-7 11-15 16-24l28 7 8-19 -25-14c3-9 5-18 6-28L635 184zM461 284c-61 0-110-49-110-110S401 64 461 64s110 49 110 110S522 284 461 284z" />
                                </g>
                                <g>
                                    <path x="-136,996" y="-136,996" class="medium"
                                        d="M392 390v-21l-28-4c-1-10-4-19-7-28l23-17 -11-18L342 313c-6-8-13-14-20-20l11-26 -18-11 -17 23c-9-4-18-6-28-7l-4-28h-21l-4 28c-10 1-19 4-28 7l-17-23 -18 11 11 26c-8 6-14 13-20 20l-26-11 -11 18 23 17c-4 9-6 18-7 28l-28 4v21l28 4c1 10 4 19 7 28l-23 17 11 18 26-11c6 8 13 14 20 20l-11 26 18 11 17-23c9 4 18 6 28 7l4 28h21l4-28c10-1 19-4 28-7l17 23 18-11 -11-26c8-6 14-13 20-20l26 11 11-18 -23-17c4-9 6-18 7-28L392 390zM255 453c-41 0-74-33-74-74 0-41 33-74 74-74 41 0 74 33 74 74C328 420 295 453 255 453z" />
                                </g>
                            </svg>
                        </div>
                    </span>
				</div>



				<!-- <i class="far fa-play-circle fa-3x" (click)="pressPlay()"></i> -->
				<!-- <i *ngIf="active" class="far fa-spinner fa-spin text-success fa-4x" (click)="$event.stopPropagation();"></i>
				<span class="arrow"><i class="far fa-arrow-right fa-3x arrowicon clickable" ></i></span> -->
				<!-- <i class="far fa-fw fa-trash fa-4x clickable" (click)=deleteLink()></i> -->
				<!-- <i *ngIf="!active" class="far fa-play-circle fa-4x text-success clickable" (click)="pressPlay()"></i>
				<i *ngIf="active" class="far fa-spinner fa-spin text-success fa-4x" (click)="$event.stopPropagation();"></i>
			</div>
		</div>
		<button (click)="deleteLink()" class="btn btn-sm add-login-button"> Delete link</button> -->
			</div>
		</div>
		<al-link-edit-info-modal></al-link-edit-info-modal>
		<al-link-edit-title-modal></al-link-edit-title-modal>
